module.exports={
    "两次输入的密码必须一致": "İkişifreninde aynı olması lazım",
    "取消": "İptal et",
    "如验证出现问题，请点击": "Onay işleminde hata olduysa, Lütfen Tıklayınız.",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "Onay işleminde hata olduysa Lütfen bizimle iletişime geçiniz. orcalivecs@asiainnovations.com",
    "如验证出现问题，请联系upcs@asiainnovations.com": "Onay işleminde hata olduysa Lütfen bizimle iletişime geçiniz. upcs@asiainnovations.com",
    "密码修改成功": "Şifre değişimi başarılı",
    "密码格式错误": "Şifre hatası",
    "密码由6-20位由数字和字母组成": "Şifre 6 ila 20 haneli ve rakam ile harften oluşmalıdır.",
    "恭喜您密码重置成功": "Tebrikler, Şifreniz değiştirildi.",
    "恭喜您已成功激活帐户": "Tebrikler, Hesabınızı başarıyla aktive ettiniz",
    "知道了": "Anladım",
    "确认修改": "Değişikliği onaylayın",
    "网络连接有误, 请稍后再试": "İnternet bağlantısında hata var, Lütfen biraz sonra tekrar deneyiniz",
    "联系客服": "Müşteri hizmetleriyle iletişime geçiniz.",
    "请再次输入密码": "Lütfen şifrenizi tekrar giriniz",
    "请返回UpVoice中重新进行邮箱验证": "Lütfen UpVoice'a geri dönüp emaille onay işlemini gerçekleştiriniz.",
    "请返回Up直播中重新进行邮箱验证": "Lütfen Uplive'a geri dönüp emaille onay işlemini gerçekleştiriniz.",
    "请返回虎鲸直播中重新进行邮箱验证": "Lütfen Lujing'e geri dönüp emaille onay işlemini gerçekleştiriniz.",
    "请重新设定登录密码": "Lütfen giriş şifrenizi tekrardan ayarlayınız",
    "请重新设置密码": "Lütfen şifrenizi sıfırlayınız",
    "赶快返回UpVoice中与全球潮人互动吧": "Hadi UpVoice dön ve dünyaya bağlan",
    "赶快返回Up直播中与全球潮人互动吧！": "Hadi Uplive dön ve dünyaya bağlan",
    "赶快返回虎鲸直播中与全球潮人互动吧": "Hadi Lujing'e dön ve dünyaya bağlan",
    "重置密码失败": "Yeniden şifre oluşturma başarasız",
    "验证失败": "Onay işlemi başarısız",
    "验证成功": "Onaylama işlemi başarılı,"
};


// WEBPACK FOOTER //
// ./js/lang/trtr.js